<template>
  <div class="container" id="container">
    <div>
      <h3 class="mt-2 mb-3">Overzicht vakantiesaldo's {{ usedYear | toYear }}</h3>
      <div>
        <button
            type="button" class="btn-basic btn-fill-pulse-dark mr-2"
            style="width: 150px;"
            id="yearButton"
            :disabled="!previousYearAvailable"
            @click="vacationCounterLastYear()">
          <svg
              class="bi bi-chevron-left" fill="currentColor"
              height="1em" viewBox="0 0 16 16"
              width="1em" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                fill-rule="evenodd"/>
          </svg>Vorig jaar
        </button>
        <button
            type="button" class="btn-basic btn-fill-pulse-dark"
            style="width: 150px;"
            id="yearButton"
            :disabled="!nextYearAvailable"
            @click="vacationCounterNextYear()">Volgend jaar
          <svg
              class="bi bi-chevron-right" fill="currentColor"
              height="1em" viewBox="0 0 16 16"
              width="1em" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
                fill-rule="evenodd"/>
          </svg>
        </button>
      </div>
      <div class="row my-2">
        <input
            ref="focusMe"
            type="text"
            class="form-control"
            placeholder="Zoeken op voornaam .."
            v-model="search"/>
      </div>
      <div class="col-auto">
        <table class="table-header-rotated center mb-4">
          <thead>
          <tr>
            <th></th>
            <th class="rotate">
              <div><span>Overdracht vakantie vorig jaar</span></div>
            </th>
            <th class="rotate">
              <div><span>Recup feestdag vorig jaar</span></div>
            </th>
            <th class="rotate">
              <div><span>Extra vakantie vorig jaar</span></div>
            </th>
            <th class="rotate">
              <div><span>Recup feestdag</span></div>
            </th>
            <th class="rotate">
              <div><span>Anciënniteitsverlof</span></div>
            </th>
            <th class="rotate">
              <div><span>Wettelijke vakantiedagen</span></div>
            </th>
            <th class="rotate">
              <div><span>Aanvullende vakantie bedienden</span></div>
            </th>
            <th class="rotate">
              <div><span>Seniorvakantie</span></div>
            </th>
            <th class="rotate">
              <div><span>Jeugdvakantie</span></div>
            </th>
            <th class="rotate">
              <div><span>Extra vakantie</span></div>
            </th>
            <th class="rotate">
              <div><span>Sollicitatieverlof</span></div>
            </th>
            <th class="rotate">
              <div><span>Wettelijke vakantie vorige werkgever</span></div>
            </th>
            <th class="rotate">
              <div><span>Vlaams Opleidingsverlof</span></div>
            </th>
          </tr>
          </thead>
          <tbody class="pointer">
          <tr v-for="user in sortedUsers" :key="user.userName">
            <th class="row-header">{{ user.userName }}</th>
            <td @click="handleClickEvent(user, user.transferHolidayPreviousYearCounter)">{{ user.transferHolidayPreviousYearCounter.currentBalance }}/{{ user.transferHolidayPreviousYearCounter.originalBalance }}</td>
            <td @click="handleClickEvent(user, user.recupPreviousYearHolidayCounter)">{{ user.recupPreviousYearHolidayCounter.currentBalance }}/{{ user.recupPreviousYearHolidayCounter.originalBalance }}</td>
            <td @click="handleClickEvent(user, user.extraVacationPreviousYearCounter)">{{  user.extraVacationPreviousYearCounter.currentBalance  }}/{{ user.extraVacationPreviousYearCounter.originalBalance }}</td>
            <td @click="handleClickEvent(user, user.recupHolidayCounter)">{{ user.recupHolidayCounter.currentBalance }}/{{ user.recupHolidayCounter.originalBalance }}</td>
            <td @click="handleClickEvent(user, user.seniorityLeaveCounter)">{{ user.seniorityLeaveCounter.currentBalance }}/{{ user.seniorityLeaveCounter.originalBalance }}</td>
            <td @click="handleClickEvent(user, user.statutoryVacationCounter)">{{ user.statutoryVacationCounter.currentBalance }}/{{ user.statutoryVacationCounter.originalBalance }}</td>
            <td @click="handleClickEvent(user, user.additionalHolidayEmployeeCounter)">{{ user.additionalHolidayEmployeeCounter.currentBalance }}/{{ user.additionalHolidayEmployeeCounter.originalBalance }}</td>
            <td @click="handleClickEvent(user, user.seniorVacationCounter)">{{ user.seniorVacationCounter.currentBalance }}/{{ user.seniorVacationCounter.originalBalance }}</td>
            <td @click="handleClickEvent(user, user.youthVacationCounter)">{{ user.youthVacationCounter.currentBalance }}/{{ user.youthVacationCounter.originalBalance }}</td>
            <td @click="handleClickEvent(user, user.extraVacationCurrentYearCounter)">{{ user.extraVacationCurrentYearCounter.currentBalance }}/{{ user.extraVacationCurrentYearCounter.originalBalance }}</td>
            <td @click="handleClickEvent(user, user.jobApplicationLeaveCounter)">{{ user.jobApplicationLeaveCounter.currentBalance }}/{{ user.jobApplicationLeaveCounter.originalBalance }}</td>
            <td @click="handleClickEvent(user, user.statutoryVacationPreviousEmployerCounter)">{{ user.statutoryVacationPreviousEmployerCounter.currentBalance }}/{{ user.statutoryVacationPreviousEmployerCounter.originalBalance }}</td>
            <td @click="handleClickEvent(user, user.educationalLeaveCounter)">{{ user.educationalLeaveCounter.currentBalance }}/{{ user.educationalLeaveCounter.originalBalance }}</td>
            <button v-if="!user.approvedByAdmin" class="btn-basic btn-outline-pulse m-2" @click="toggleApprovedByAdmin(user.userId, true)">Goedkeuren</button>
            <button v-else class="btn-basic btn-red m-2" @click="toggleApprovedByAdmin(user.userId, false)">Afkeuren</button>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <UpdateVacationCounterModal
        :user="user" :counter="counter"
        :year="year">
    </UpdateVacationCounterModal>
  </div>

</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import {VoerroModal} from "@voerro/vue-modal";
import UpdateVacationCounterModal from "@/components/modals/UpdateVacationCounterModal";
import {toYear} from "@/util/DateUtil";


export default {
  name: "AdminVacationView",
  components: {
    UpdateVacationCounterModal
  },
  data: () => ({
    search: '',
    user: {},
    counter: {},
    year: undefined,
    currentYear: new Date().getFullYear().toString()
  }),
  computed: {
    ...mapGetters({
      userWithVacationCounters: "administrationUser/vacationCounters",
      usedYear: "administrationUser/usedYear",
      previousYearAvailable: "administrationUser/previousYearAvailable",
      nextYearAvailable: "administrationUser/nextYearAvailable"
    }),
    sortedUsers: function () {
      let sortedList = this.userWithVacationCounters;
      sortedList.sort((user1, user2) => (user1.userName > user2.userName) ? 1 : ((user1.userName < user2.userName) ? -1 : 0));
      return sortedList.filter(user => {
        return user.userName.toLowerCase().includes(this.search.toLowerCase());
      });
    },
  },
  created() {
    this.fetchVacationBalanceForAllUsersSpecificYear(new Date(this.usedYear).getFullYear().toString());
  },
  methods: {
    ...mapActions("administrationUser", ["fetchVacationBalanceForAllUsersSpecificYear", "updateApprovedByAdmin"]),
    ...mapMutations("administrationUser", ["updateUsedYear", "setCurrentBalance", "setOriginalBalance"]),
    handleClickEvent(user, counter) {
      this.user = user;
      this.counter = counter;
      this.setCurrentBalance(counter.currentBalance);
      this.setOriginalBalance(counter.originalBalance);
      this.year = toYear(this.usedYear);
      VoerroModal.show('updateVacationCounter');
    },
    vacationCounterNextYear() {
      const nextYear = new Date(this.usedYear).getFullYear() + 1;
      this.updateUsedYear(nextYear);
      this.fetchVacationBalanceForAllUsersSpecificYear(nextYear.toString());
    },
    vacationCounterLastYear() {
      const lastYear = new Date(this.usedYear).getFullYear() - 1;
      this.updateUsedYear(lastYear);
      this.fetchVacationBalanceForAllUsersSpecificYear(lastYear.toString());
    },
    toggleApprovedByAdmin(userId, isApprovedByAdmin) {
      this.updateApprovedByAdmin({userId, isApprovedByAdmin});
    }
  }
};
</script>

<style scoped>
.table-header-rotated {
  border-collapse: collapse;
}
.table-header-rotated td {
  width: 30px;
}
.table-header-rotated th {
  padding: 5px 10px;
}
.table-header-rotated td {
  text-align: center;
  padding: 10px 5px;
  border: 1px solid #ccc;
}
.table-header-rotated th.rotate {
  height: 140px;
  white-space: nowrap;
}
.table-header-rotated th.rotate > div {
  -webkit-transform: translate(25px, 51px) rotate(315deg);
  -ms-transform: translate(25px, 51px) rotate(315deg);
  transform: translate(25px, 51px) rotate(315deg);
  width: 30px;
}
.table-header-rotated th.rotate > div > span {
  border-bottom: 1px solid #ccc;
  padding: 5px 10px;
}
.table-header-rotated th.row-header {
  padding: 0 10px;
  border: 1px solid #ccc;
  width: 1000px;
}
.center {
  margin-left: auto;
  margin-right: auto;
  margin-top: 100px;
}
td, th {
  width: 300px;
}
#yearButton {
  width: 130px;
}

.pointer td {
  cursor: pointer;
}
</style>